import { Action, createAction, props } from '@ngrx/store';

export enum AuthActionTypes {
  LoginAttempted = '[Login Page] User attempted to log in',
  LoginSuccessful = '[Auth API] Login successful',
  LoginFailed = '[Auth API] Login failed',
  LogoutRequested = '[Navbar] Logout requested',
  LogoutSuccessful = '[Auth API] Logout successful',
  SsoLogin = '[Auth API] Sso Login',
  SsoLoginSuccessful = '[Auth API] Sso Login successful',
}

export const loginAttempted = createAction(
  AuthActionTypes.LoginAttempted,
  props<{ payload?: any }>(),
);

export const loginFailed = createAction(AuthActionTypes.LoginFailed, props<{ payload?: any }>());

export const loginSuccessful = createAction(
  AuthActionTypes.LoginSuccessful,
  props<{ payload?: any }>(),
);

export const logoutRequested = createAction(
  AuthActionTypes.LogoutRequested,
  props<{ payload?: any }>(),
);

export const logoutSuccessful = createAction(
  AuthActionTypes.LogoutSuccessful,
  props<{ payload?: any }>(),
);

export const ssoLogin = createAction(AuthActionTypes.SsoLogin, props<{ payload?: any }>());

export const ssoLoginSuccessful = createAction(
  AuthActionTypes.SsoLoginSuccessful,
  props<{ payload?: any }>(),
);

export type AuthActions = ReturnType<
  | typeof loginAttempted
  | typeof loginFailed
  | typeof loginSuccessful
  | typeof logoutRequested
  | typeof logoutSuccessful
  | typeof ssoLogin
  | typeof ssoLoginSuccessful
>;
